const formatValidationItem = (item) => {
  if (typeof item === "string") {
    return item;
  }

  if (!item || typeof item !== "object") {
    return "";
  }

  const location = Array.isArray(item.loc)
    ? item.loc.filter((part) => part !== "body").join(".")
    : "";

  if (item.msg && location) {
    return `${location}: ${item.msg}`;
  }

  if (item.msg) {
    return item.msg;
  }

  return "";
};

export const getApiErrorMessage = (error, fallback = "Request failed") => {
  const detail = error?.response?.data?.detail;

  if (typeof detail === "string" && detail.trim()) {
    return detail;
  }

  if (Array.isArray(detail)) {
    const message = detail
      .map((item) => formatValidationItem(item))
      .filter(Boolean)
      .join(" | ");

    if (message) {
      return message;
    }
  }

  if (detail && typeof detail === "object") {
    const message = formatValidationItem(detail);
    if (message) {
      return message;
    }

    if (typeof detail.message === "string" && detail.message.trim()) {
      return detail.message;
    }
  }

  if (typeof error?.response?.data?.message === "string" && error.response.data.message.trim()) {
    return error.response.data.message;
  }

  if (typeof error?.message === "string" && error.message.trim()) {
    return error.message;
  }

  return fallback;
};
